<template>
  <a-breadcrumb class="breadcrumb">
    <template
      v-for="(it, id) in breadcrumbList"
    >
      <a-breadcrumb-item
        :key="id"
      >
        {{it.meta.title}}
      </a-breadcrumb-item>
    </template>
  </a-breadcrumb>
</template>

<script>

export default {
  name: 'Breadcrumb',
  props: {
    breadcrumbList: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped lang="less">

</style>
